import jerry from '@/assets/team/jerry-james-maafo.png'
import kathy from '@/assets/team/kathy-yawa-vulor.jpg'
import bright from '@/assets/team/bright-xoxoli-ahiadzor.jpg'
import bridget from '@/assets/team/bridget-bansah.jpg'
import hope from '@/assets/team/kodjo-hope-agbalemenya.jpg'
import christopher from '@/assets/team/christopher-n-nankwe.jpg'
import kelly from '@/assets/team/ebenezer-kelly-fordjour.jpg'
import cathy from '@/assets/team/cathy-oyie-aboagye.jpg'
import ruweida from '@/assets/team/ruweida-abdul-karim.png'
import francis from '@/assets/team/francis-inkoom-ninson.png'
import melinda from '@/assets/team/melinda-njibiche.jpeg'
import type { Member } from '@/types/team'

export const featuredMember: Member = {
  name: 'Jerry James Maafo',
  role: 'President',
  image: jerry,
}

export const teamMembers: Member[] = [
  { name: 'Kathy Yawa Vulor', role: 'Project Director', image: kathy },
  {
    name: 'Bright Xoxoli Ahiadzor',
    role: 'Business, Entrepreneurship & Internal Audit',
    image: bright,
  },
  {
    name: 'Bridget Bansah',
    role: 'Director, Education & Innovation',
    image: bridget,
  },
  {
    name: 'Kodjo Hope Agbalemenya',
    role: 'Director, Culture & Creative Arts',
    image: hope,
  },
  {
    name: 'Christopher Hassan N-Nankwe',
    role: 'Media and Marketing',
    image: christopher,
  },
  { name: 'Ebenezer Kelly Fordjour', role: 'Photography and Editing', image: kelly },
  { name: 'Cathy Oyie Aboagye', role: 'Administrative Secretary', image: cathy },
  { name: 'Ruweida Abdul Karim', role: 'Content Creator & Face of IBON World', image: ruweida },
  { name: 'Francis Inkoom Ninson', role: 'Administrator & Account Officer', image: francis },
  {
    name: 'Melinda Seyram Njibiche',
    role: 'Head of Innovation & International Relations',
    image: melinda,
  },
]
